import {StyleSheet} from 'react-native';

const styles = StyleSheet.create({
  title: {
    fontSize: 16,
  },
  content: {
    fontSize: 14,
  },
  bold: {
    fontWeight: 'bold',
  },
  colorWhite: {
    color: 'white',
  },
  info: {
    backgroundColor: '#0F579E',
    maxHeight: 15,
    width: 15,
    height: 15,
    borderRadius: 15,
    flex: 1,
    flexBasis: 15,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: -2,
    marginHorizontal: 4,
    position: 'relative',
  },

  // label: {
  //   marginRight: 20,
  //   marginLeft: 20,
  //   fontSize: 16,
  //   fontWeight: 'normal',
  //   color: 'black',
  // },

  centeredView: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    marginTop: 22,
  },
  modalView: {
    margin: 20,
    backgroundColor: 'white',
    borderRadius: 20,
    padding: 35,
    alignItems: 'center',
    shadowColor: '#000',
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    elevation: 5,
    minWidth: 220,
  },
  openButton: {
    backgroundColor: '#0F579E',
    borderRadius: 30,
    padding: 16,
    marginTop: 16,
  },
  textStyle: {
    color: 'white',
    fontWeight: 'bold',
    textAlign: 'center',
  },
  // modalText: {
  //   marginBottom: 15,
  //   textAlign: 'center',
  // },
});
export default styles;
